import React, { Component } from 'react'
import { Button, Box, Heading, Tabs, Logo, Text, Clipped, Form, Level, Toasts } from '@deseretbook/react-ui'
import { withCheckout } from './CheckoutContext'
import ShipmentPanel from './ShipmentPanel'
import { DeseretBook } from '../../dbcom/api'
import { Logger, formatErrorMessage } from '../../dbcom'

const logger = new Logger({ context: 'DeliveryStep' })

class DeliveryStep extends Component {
  constructor(props) {
    super(props)

    this.shipmentAttributes = []

    this.state = {
      isLoading: false,
      propsIsActive: null,
    }

    this.handleShipmentChanges = this.handleShipmentChanges.bind(this)
    this.saveDeliveryStep = this.saveDeliveryStep.bind(this)
  }

  static getDerivedStateFromProps(props, state) {
    const { order, isActive } = props
    const { propsIsActive } = state

    if (isActive !== propsIsActive) {
      return {
        propsIsActive: isActive,
        shipmentAttributes: order.shipments
          .map(({ id, shippingRates }) => {
            const selectedShippingRate = shippingRates
              .filter(({ selected }) => selected)[0] || {}

            return {
              id,
              selectedShippingRateId: selectedShippingRate.id,
            }
          }),
      }
    }

    return null
  }

  handleShipmentChanges(shipment, changes) {
    this.setState(({ shipmentAttributes }) => ({
      shipmentAttributes: shipmentAttributes
        .reduce((completed, attributes) => {
          if (attributes.id === shipment.id) {
            return [
              ...completed,
              {
                ...attributes,
                ...changes,
              },
            ]
          }

          return [
            ...completed,
            attributes,
          ]
        }, []),
    }))
  }

  saveDeliveryStep() {
    const { order, updateOrder, startLoading, stopLoading } = this.props
    const { shipmentAttributes } = this.state


    startLoading(() => {
      this.setState({ isLoading: true }, async () => {
        try {
          const updatedOrder = await DeseretBook
            .checkout(order)
            .update({
              state: 'delivery',
              shipmentsAttributes: shipmentAttributes,
            })

          stopLoading(this.setState({ isLoading: false }))
          Toasts.success('Delivery method saved')
          updateOrder(updatedOrder, true)
        } catch ({ message, errors }) {
          logger.error(`Unable to save delivery step: "${formatErrorMessage(message, errors)}"`, { errors, order })
          Toasts.danger('Unable to save delivery', formatErrorMessage(message, errors))
          stopLoading(this.setState({ isLoading: false }))
        }
      })
    })
  }

  /**
   * Loops through each shipment and display the shipping manifest
   */
  render() {
    const { stores, order, onCloseStep } = this.props
    const { isLoading, shipmentAttributes } = this.state

    return (
      <Form onSubmit={this.saveDeliveryStep} isSubmitting={isLoading}>
        {
          order.shipments
            .map(shipment => (
              <ShipmentPanel
                key={shipment.id}
                shipment={shipment}
                form={shipmentAttributes.filter(({ id }) => id === shipment.id)[0]}
                stores={stores}
                onShipmentChange={changes => this.handleShipmentChanges(shipment, changes)}
                isLoading={isLoading}
              />
            ))
        }

        <Level>
          <Level.Right>
            {
            order.state !== 'delivery'
              ? (
                <Level.Item>
                  <Button
                    type="button"
                    onClick={onCloseStep}
                    disabled={isLoading}
                  >
                      Cancel
                  </Button>
                </Level.Item>
              )
              : null
          }
            <Level.Item>
              <Form.SubmitButton color="action">
                {
                  order.state === 'address'
                    ? 'Continue'
                    : 'Save Changes'
                }
              </Form.SubmitButton>
            </Level.Item>
          </Level.Right>
        </Level>
      </Form>
    )
  }
}

export default withCheckout(DeliveryStep)
